import { useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';

const TOOLTIP_ENTER_DELAY_MS = 300;

const ImmediateCloseTooltip = ({ title = '', disableHover = false, children }) => {
  const [open, setOpen] = useState(false);
  const tooltipTitle = String(title ?? '').trim();

  useEffect(() => {
    if (!open) return undefined;

    const closeTooltip = () => setOpen(false);
    window.addEventListener('wheel', closeTooltip, true);
    window.addEventListener('scroll', closeTooltip, true);
    window.addEventListener('touchmove', closeTooltip, true);

    return () => {
      window.removeEventListener('wheel', closeTooltip, true);
      window.removeEventListener('scroll', closeTooltip, true);
      window.removeEventListener('touchmove', closeTooltip, true);
    };
  }, [open]);

  if (disableHover || !tooltipTitle) return children;

  return (
    <Tooltip
      title={tooltipTitle}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      enterDelay={TOOLTIP_ENTER_DELAY_MS}
      enterNextDelay={TOOLTIP_ENTER_DELAY_MS}
      leaveDelay={0}
      disableInteractive
      TransitionProps={{ timeout: 0 }}
    >
      {children}
    </Tooltip>
  );
};

export default ImmediateCloseTooltip;
